import { apiClient } from '@services/api-client'
import { BACK_OFFICE_PREFIX } from '@services/utils'
import { useMutation, useQueryClient } from '@tanstack/react-query'

import type { BankNotification } from '@features/banking/types'

import { bankNotificationsQueryKey } from '../queries/useBankNotificationsTable'

interface Variables {
  id: string
  rentId: string
}

export function useMatchNotification() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({ id, rentId }: Variables): Promise<BankNotification> => {
      const res = await apiClient.post<BankNotification>(
        `${BACK_OFFICE_PREFIX}bank-notifications/${id}/match`,
        { rent_id: rentId }
      )
      return res.data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: bankNotificationsQueryKey })
      // Spárovanie označí predpis zaplateným, takže zoznamy nájmov sú neaktuálne.
      queryClient.invalidateQueries({ queryKey: ['rents'] })
      queryClient.invalidateQueries({ queryKey: ['dashboard-unpaid-rents'] })
    }
  })
}
